import { usePhanHeKhamBenhContext } from "../../contexts/PhanHeTiepDonContext";
import LichSuPhieuKhamBenh from "./LichSuPhieuKhamBenh";

const TabLichSuPhieuDieuTri = () => {
  const { benhNhanInfo } = usePhanHeKhamBenhContext();

  return <LichSuPhieuKhamBenh patientId={benhNhanInfo?.thongTinKhamBenh?.patientId} />;
};

export default TabLichSuPhieuDieuTri;
